import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { TFMService } from 'app/mock-api/tfm.service';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private tfmService = inject(TFMService);

    public view : any = {
        isClient:false
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) =>
            {
                navigation.horizontal = [];

                navigation.horizontal.push(
                    { id: "home", title: "HOME", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                    { id: "about", title: "ABOUT US", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us"},
                    // { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "about-us" },
                    { id: "members", title: "OUR MEMBERS", subtitle: "", type: "basic", icon: "", children: [], link: "/branches" }, 
                    { id: "corporate-travel", title: "CORPORATE", subtitle: "", type: "basic", icon: "", children: [], link: "/corporate-travel" },
                    { id: "leisure-travel", title: "HOLIDAYS", subtitle: "",  type: "basic", icon: "", children: [], link: "/packages"},
                    { id: "promotional", title: "SPECIALS", subtitle: "",  type: "basic", icon: "", children: [], link: "/promotional"},
                    // { id: "leisure-travel", title: "Leisure ", subtitle: "", type: "group", icon: "", children:destinations},
                    // { id: "eco-system", title: "Eco-System", subtitle: "", type: "collapsable", icon: "", 
                    //     children: [
                    //         { id: "howzit", title: "Howzit", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-howzit", queryParams: { type: 'howzit' } },
                    //         { id: "holidays", title: "Holidays", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-holidays",queryParams: { type: 'xl-holidays' }  }
                    //     ]
                    // },
                    // { id: "rewards", title: "Rewards", subtitle: "", type: "basic", icon: "", children: [], link: "/rewards/rewards-page", queryParams: { type: 'rewards' } },
                    { id: "travel-app", title: "XLGO TRAVEL APP", subtitle: "", type: "basic", icon: "", children: [], link: "https://www.xltravel.co.za/xlgo/", externalLink:true, target:"_blank" },
                    { id: "contact", title: "CONTACT", subtitle: "", type: "basic", icon: "", children: [], link: "/contact-us" }
                );
                
                if (this.view.isClient && false) {
                    this.tfmService.getSite().then((resSite: any) => {
                        this.view.site = resSite;
                        var profile = this.tfmService.getSiteProfile(this.view.site.id);

                        console.log("PROFILE", profile);
                        if (this.view.site && this.view.site.profile && this.view.site.profile.heading) {
                            console.log("SENDING NAV 0", navigation, this.view);
                            if (this.view.site.profile.heading.menu == 2) {
                                navigation.horizontal.push(
                                    { id: "home", title: "HOME", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                    { id: "about", title: "ABOUT US", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us"},
                                    // { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "about-us" },
                                    { id: "members", title: "OUR MEMBERS", subtitle: "", type: "basic", icon: "", children: [], link: "branches" }, 
                                    { id: "corporate-travel", title: "CORPORATE", subtitle: "", type: "basic", icon: "", children: [], link: "corporate-travel" },
                                    { id: "leisure-travel", title: "BOOK A HOLIDAY", subtitle: "",  type: "basic", icon: "", children: [], link: "packages"},
                                    // { id: "leisure-travel", title: "Leisure ", subtitle: "", type: "group", icon: "", children:destinations},
                                    // { id: "eco-system", title: "Eco-System", subtitle: "", type: "collapsable", icon: "", 
                                    //     children: [
                                    //         { id: "howzit", title: "Howzit", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-howzit", queryParams: { type: 'howzit' } },
                                    //         { id: "holidays", title: "Holidays", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-holidays",queryParams: { type: 'xl-holidays' }  }
                                    //     ]
                                    // },
                                    // { id: "rewards", title: "Rewards", subtitle: "", type: "basic", icon: "", children: [], link: "/rewards/rewards-page", queryParams: { type: 'rewards' } },
                                    { id: "travel-app", title: "XLGO TRAVEL APP", subtitle: "", type: "basic", icon: "", children: [], link: "https://www.xltravel.co.za/xlgo/", externalLink:true, target:"_blank" },
                                    { id: "contact", title: "CONTACT", subtitle: "", type: "basic", icon: "", children: [], link: "contact" }
                                );

                                console.log("sending nav", navigation);
                                this._navigation.next(navigation);
                            }
                            else {
                                this.tfmService.getDestinations().then((res:any) => {
                                    // console.log(res);
                                    var destinations = [];
                                    res.forEach(x => {
                                        destinations.push(
                                            { id: x.id, title: x.name, type: "basic", icon: "", link: `/destination/${x.id}/${x.seo.alias}` }
                                        ); 
                                    });
                                    // var destinationsJson = JSON.stringify(destinations);
                                    // this.tfmService.getPages().then(res => {
                                        
                                    // });

                                    this.view.pages = res;
                                    // console.log("Get pages", this.view.pages.content);
                                
                                    navigation.horizontal = [];
                                    
                                    if (this.view.site && this.view.site.profile && this.view.site.profile.heading) {
                                        switch (this.view.site.profile.heading.menu) {
                                            case 1: {
                                                navigation.horizontal.push(
                                                    { id: "home", title: "Home", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                                    { id: "destinations", title: "Destinations", subtitle: "", type: "group", icon: "", children: destinations },
                                                    { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us" },
                                                    { id: "contact", title: "Contact", subtitle: "", type: "basic", icon: "", children: [], link: "/contact" },
                                                );
                                                break;
                                            }
                                            case 2: {
                                                navigation.horizontal.push(
                                                    { id: "home", title: "HOME", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                                    { id: "about", title: "ABOUT US", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us"},
                                                    // { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "about-us" },
                                                    { id: "members", title: "OUR MEMBERS", subtitle: "", type: "basic", icon: "", children: [], link: "branches" }, 
                                                    { id: "corporate-travel", title: "CORPORATE", subtitle: "", type: "basic", icon: "", children: [], link: "corporate-travel" },
                                                    { id: "leisure-travel", title: "BOOK A HOLIDAY", subtitle: "",  type: "basic", icon: "", children: [], link: "packages"},
                                                    // { id: "leisure-travel", title: "Leisure ", subtitle: "", type: "group", icon: "", children:destinations},
                                                    // { id: "eco-system", title: "Eco-System", subtitle: "", type: "collapsable", icon: "", 
                                                    //     children: [
                                                    //         { id: "howzit", title: "Howzit", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-howzit", queryParams: { type: 'howzit' } },
                                                    //         { id: "holidays", title: "Holidays", subtitle: "", type: "basic", icon: "", link: "/holidays/xl-holidays",queryParams: { type: 'xl-holidays' }  }
                                                    //     ]
                                                    // },
                                                    // { id: "rewards", title: "Rewards", subtitle: "", type: "basic", icon: "", children: [], link: "/rewards/rewards-page", queryParams: { type: 'rewards' } },
                                                    { id: "travel-app", title: "XLGO TRAVEL APP", subtitle: "", type: "basic", icon: "", children: [], link: "https://www.xltravel.co.za/xlgo/", externalLink:true, target:"_blank" },
                                                    { id: "contact", title: "CONTACT", subtitle: "", type: "basic", icon: "", children: [], link: "contact" }
                                                );
                                                break;
                                            }
                                            case 3: {
                                                navigation.horizontal.push(
                                                    { id: "home", title: "Home", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                                    { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us" },
                                                    { id: "world-cruises", title: "World Cruises", subtitle: "", type: "basic", icon: "", children: [], link: "/world-cruises" },
                                                    { id: "gallery", title: "Gallery", subtitle: "", type: "basic", icon: "", children: [], link: "/gallery" },
                                                    { id: "contact", title: "Contact", subtitle: "", type: "basic", icon: "", children: [], link: "/contact" },
                                                    
                                                );
                                                break;
                                            }
                                            default: {
                                                //console.log('No matching case found for services');
                                            }
                                        }
                                    }

                                    this._navigation.next(navigation);
                                    //console.log("This is a Navigation data :",this.navigation, this.view.site);
                                });
                            }
                        }
                        else {
                            console.log("SENDING NAV -1", navigation, this.view);
                        }
                    });
                }
                else {          
                    this._navigation.next(navigation);
                }   
            }),
        );
    }
}
